export default "/images/ic-send.svg?6864602ab7960f41dfb81c0e5f67da55";